import type { Tour } from '../tour-types';

/**
 * The variant combination report. Everything after the picker only exists once two
 * experiments are selected, so a first visit usually sees just the first step; the rest
 * show on a replay, or when the page opens with a selection in its URL. The results and
 * the no-window notice are alternatives, and only one of them is ever on screen.
 */
export const combinationTour: Tour = {
  key: 'combination',
  version: 1,
  routes: ['/experiments/combination-report'],
  steps: [
    {
      anchor: 'combination-experiments',
      placement: 'bottom',
      title: 'Pick experiments',
      body: 'Use this when two experiments ran at the same time, to check whether one changed the result of the other. Select at least two that overlapped on dates and on a device type; ones that cannot be combined are hidden.',
    },
    {
      anchor: 'combination-window',
      placement: 'bottom',
      title: 'Shared run window',
      body: 'The days the selected experiments ran together, and the devices they share. Only visitors from that overlap can be in a combination, so a short window means few conversions to read.',
    },
    {
      anchor: 'combination-no-window',
      placement: 'bottom',
      title: 'Never ran together',
      body: 'These experiments were never splitting traffic at the same time, often because one had already deployed a variant. Pick experiments whose randomising periods overlap.',
    },
    {
      anchor: 'combination-results',
      placement: 'top',
      title: 'Combination performance',
      body: 'Conversions, revenue and order value for each mix of variants, counted only over the period both were randomising. There is no conversion rate, because the traffic each combination got is not recorded.',
    },
    {
      anchor: 'combination-interaction',
      placement: 'left',
      title: 'Interaction',
      body: 'Above 1 the two changes reinforce each other, below 1 they interfere, and a range that includes 1 is not a finding. Hover a value for a plain reading of it.',
    },
  ],
};
